import { render } from "./Returns.vue?vue&type=template&id=8fc6ce6e&scoped=true&ts=true"
import script from "./Returns.vue?vue&type=script&lang=ts"
export * from "./Returns.vue?vue&type=script&lang=ts"

import "./Returns.vue?vue&type=style&index=0&id=8fc6ce6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc6ce6e"]])

export default __exports__